<header class="ba-content-header">

    <div class="ba-content-wrap">

        <app-breadcrumb [postfachLabel]="'breadcrumb.mailbox' | i18next" [isPostfach]="page === PagesEnum.Mailbox"></app-breadcrumb>
        <h1>{{ title}}</h1>
        @if (subtitle) {
            <p>{{subtitle}}</p>
        }
    </div>
</header>